"use strict";

let textArea = document.querySelector('#form-nachricht');

function resizeTextArea() {
    textArea.style.height = '35px';
    textArea.style.minHeight = (textArea.scrollHeight) + 'px';
}

if (textArea) {
    textArea.addEventListener('input', resizeTextArea);
    resizeTextArea();
}
